import * as constants from './constants';

const initialState = {
  allUsers: [],
  currentUserObj: {},
  createProjectLoading: false,
  currentProjectObj: {},
  ProjectDetailsIsEdit: false,
  fetchProjectsLoading: false,
  deleteProjectLoading: false,
  utilsData: {},
  createUserLoading: false,
  userDetailsIsEdit: false,
  userPermissionsIsEdit: false,
  fetchUsersLoading: false,
  deleteUserLoading: false,
  settingsLoading: false,
  sendDetailLoading: false,
  fetchUserDetailLoading: false,
  settingsUpdatingKey: {
    browser_notifications: false,
    email_notifications: false,
    mobile_notifications: false,
  },
  totalRecords: 0,
  browserNotLoading: false,
  emailNotLoading: false,
  mobileNotLoading: false,
  permissionsLoading: false,
  isEditProjectPermissions: false,
  sortedInfo: null,
  page: 1,
  resultPerPage: 10,
  search: {},
};

const tenantUserManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_TENANT_USERS_UTIL_DATA_SUCCESS:
      return {
        ...state,
        utilsData: {
          ...action.data,
        },
      };

    case constants.TENANT_USER_DETAILS_IS_EDIT:
      return {
        ...state,
        userDetailsIsEdit: action.data,
      };
    case constants.SET_TENANT_USER_PERMISSIONS_IS_EDIT:
      return {
        ...state,
        userPermissionsIsEdit: action.data,
      };
    case constants.CREATE_TENANT_USER:
      return {
        ...state,
        createUserLoading: true,
      };
    case constants.CREATE_TENANT_USER_SUCCESS:
      return {
        ...state,
        createUserLoading: false,
        currentUserObj: action.data,
        userDetailsIsEdit: false,
        departmentIsEdit: true,
      };
    case constants.CREATE_TENANT_USER_ERROR:
      return {
        ...state,
        createUserLoading: false,
      };
    case constants.UPDATE_TENANT_USER:
      return {
        ...state,
        createUserLoading: true,
      };
    case constants.UPDATE_TENANT_USER_SUCCESS:
      return {
        ...state,
        createUserLoading: false,
        currentUserObj: action.data,
        userDetailsIsEdit: false,
      };
    case constants.UPDATE_TENANT_USER_ERROR:
      return {
        ...state,
        createUserLoading: false,
      };
    case constants.UPDATE_TENANT_USER_PERMISSIONS:
      return {
        ...state,
        permissionsLoading: true,
      };
    case constants.UPDATE_TENANT_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissionsLoading: false,
        currentUserObj: action.data,
        userPermissionsIsEdit: false,
      };
    case constants.UPDATE_TENANT_USER_PERMISSIONS_ERROR:
      return {
        ...state,
        permissionsLoading: false,
      };
    case constants.ADD_TENANT_USER_IN_MANAGER:
      return {
        ...state,
        createUserLoading: true,
      };
    case constants.FETCH_ALL_TENANT_USERS:
      return {
        ...state,
        fetchUsersLoading: true,
        allUsers: [],
      };
    case constants.FETCH_ALL_TENANT_USERS_SUCCESS:
      const { total_users, users } = action.data;
      return {
        ...state,
        allUsers: users,
        fetchUsersLoading: false,
        totalRecords: total_users,
      };
    case constants.FETCH_ALL_TENANT_USERS_ERROR:
      return {
        ...state,
        fetchUsersLoading: false,
      };
    case constants.DELETE_TENANT_USER:
      return {
        ...state,
        deleteUserLoading: true,
      };
    case constants.DELETE_TENANT_USER_SUCCESS:
      let updatedUsers = state.allUsers.filter(
        (el) => el._id !== action.data._id
      );
      let totalRecords = state.totalRecords - 1;
      return {
        ...state,
        totalRecords: totalRecords,
        deleteUserLoading: false,
        allUsers: updatedUsers,
      };
    case constants.DELETE_TENANT_USER_ERROR:
      return {
        ...state,
        deleteUserLoading: false,
      };

    case constants.FETCH_TENANT_USER:
      return {
        ...state,
        // departmentLoading: true,
        fetchUserDetailLoading: true,
      };
    case constants.FETCH_TENANT_USER_SUCCESS:
      return {
        ...state,
        currentUserObj: action.data,
        fetchUserDetailLoading: false,
      };
    case constants.FETCH_TENANT_USER_ERROR:
      return {
        ...state,
        fetchUserDetailLoading: false,
      };
    case constants.SEND_DETAILS_TO_TENANT_USER:
      return {
        ...state,
        sendDetailLoading: true,
      };
    case constants.SEND_DETAILS_TO_TENANT_USER_SUCCESS:
      return {
        ...state,
        sendDetailLoading: false,
      };
    case constants.SEND_DETAILS_TO_TENANT_USER_ERROR:
      return {
        ...state,
        sendDetailLoading: false,
      };
    case constants.UPDATE_TENANT_USER_SETTINGS:
      const { data, loadingObj } = action.data;
      const { id, ...res } = data;
      return {
        ...state,
        settingsLoading: true,
        settingsUpdatingKey: { ...state.settingsUpdatingKey, ...res },
        ...loadingObj,
      };
    case constants.UPDATE_TENANT_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        currentUserObj: { ...state.currentUserObj, ...action.data.data },
        // settingsUpdatingKey: { ...state.settingsUpdatingKey, ...res },
        settingsLoading: false,
        ...action.data.loadingObj,
      };
    case constants.UPDATE_TENANT_USER_SETTINGS_ERROR:
      return {
        ...state,
        settingsLoading: false,
        currentClientObj: {
          ...state.currentClientObj,
        },
      };

    case constants.SET_TENANT_USERS_MANAGER_STATE:
      const { sortedInfo, page, resultPerPage, search } = state;

      const storageData = { sortedInfo, page, resultPerPage, search };

      localStorage.setItem(
        'tenantUsersManagerState',
        JSON.stringify({ ...storageData, ...action.data })
      );

      return {
        ...state,
        ...action.data,
      };
    case constants.TENANT_USER_DETAIL_CLEANUP_FUNC:
      return {
        ...state,
        allUsers: [],
        createUserLoading: false,
        currentUserObj: {},
        user_projects: [],
        userDetailsIsEdit: false,
        fetchUsersLoading: false,
        deleteUserLoading: false,
        createProjectLoading: false,
        currentProjectObj: {},
        ProjectDetailsIsEdit: false,
        fetchProjectsLoading: false,
        deleteProjectLoading: false,
        departmentLoading: false,
        departmentIsEdit: false,
        departmentsList: [],
        departItemsIndex: null,
        isEditProjectPermissions: false,
      };
    default:
      return state;
  }
};

export default tenantUserManagerReducer;
